const SECRET_FIELD = /^(?:authorization|proxy-authorization|cookie|set-cookie|password|passwd|secret|client_secret|api[_-]?key|access[_-]?token|refresh[_-]?token|token)$/i;

function safeString(value: string): string {
  // Fetch/console breadcrumbs can contain a complete generated customer PDF.
  // Redact the whole string, including wrapped or whitespace-separated data.
  if (/data:[^\s,;]*(?:;[^,]*)?,/i.test(value)) return '[redacted inline data URL]';
  const strip = (raw: string) => {
    const boundary = raw.search(/[?#]/);
    return boundary < 0 ? raw : `${raw.slice(0, boundary)}[redacted URL parameters]`;
  };
  return value
    .replace(/https?:\/\/[^\s"'<>]+/gi, strip)
    .replace(/\/(?!\/)[^\s"'<>]*[?#][^\s"'<>]*/g, strip);
}

/** Copy only: Sentry and application code may still hold the original object. */
export function sanitizeSentryPayload<T>(payload: T): T {
  const seen = new WeakSet<object>();
  function copy(value: unknown): unknown {
    if (typeof value === 'string') return safeString(value);
    if (!value || typeof value !== 'object') return value;
    if (seen.has(value)) return '[circular]';
    seen.add(value);
    try {
      if (Array.isArray(value)) return value.map(copy);
      if (value instanceof Date) return value.toISOString();
      return Object.fromEntries(Object.entries(value).map(([key, nested]) => [
        key, SECRET_FIELD.test(key) ? '[redacted]' : copy(nested),
      ]));
    } finally {
      seen.delete(value);
    }
  }
  return copy(payload) as T;
}
